/* eslint-disable */
import {
  DELIVERY_ORDER_STATUS_ALL,
  DELIVERY_ORDER_STATUS_COMPLETED,
  DELIVERY_ORDER_STATUS_DELIVERED,
  DELIVERY_ORDER_STATUS_LIVE,
  DELIVERY_ORDER_STATUS_SCHEDULED,
} from '../../Constants/Delivery/Delivery.constants';
import { I18N_LANG_AR_AE, I18N_LANG_EN_AU, I18N_LANG_ZH_CN } from '../../Constants/I18n/I18n.constants';
import throwDeliveryInvalidOrderStatusError from '../../Errors/Delivery/DeliveryInvalidOrderStatus.error';
import i18nStore from '../../Support/I18n/Store/I18nStore.support';

/**
 * The `key` to use to store the `translations`
 */
const key = `DeliveryService`;

i18nStore.add(I18N_LANG_AR_AE, key, {
  Delivery: {
    Customer: {
      Name: `اسم الزبون`,
    },
    DocketId: `رقم التذكرة`,
    DocketTime: `تاريخ / وقت`,
    Instructions: {
      Comments: `تعليقات`,
      FollowTruckId: `اتبع شاحنة معرف`,
    },
    Order: {
      Status: `الحالة`,
    },
    PlantCoordinates: `مرجع الخريطة`,
    Product: {
      Additives: `إضافات`,
      AggregatedSize: `الحجم المجمع`,
      Description: `وصف المنتج`,
      Slump: `ركود`,
    },
    Quantity: {
      Progress: `تقدم الكمية`,
      Total: `مجموع`,
    },
    Site: {
      Address: `عنوان الموقع`,
    },
    TruckNumber: `رقم الشاحنة`,
  },
  DeliveryOrderStatus: ({ deliveryOrderStatus }) => {
    if (deliveryOrderStatus === DELIVERY_ORDER_STATUS_ALL) {
      return `الكل`;
    }
    if (deliveryOrderStatus === DELIVERY_ORDER_STATUS_COMPLETED) {
      return `منجز`;
    }
    if (deliveryOrderStatus === DELIVERY_ORDER_STATUS_DELIVERED) {
      return `تم التوصيل`;
    }
    if (deliveryOrderStatus === DELIVERY_ORDER_STATUS_LIVE) {
      return `حي`;
    }
    if (deliveryOrderStatus === DELIVERY_ORDER_STATUS_SCHEDULED) {
      return `المقرر`;
    }
    return throwDeliveryInvalidOrderStatusError(deliveryOrderStatus);
  },
});

i18nStore.add(I18N_LANG_EN_AU, key, {
  Delivery: {
    Customer: {
      Name: `Customer Name`,
    },
    DocketId: `Docket Id`,
    DocketTime: `Date/Time`,
    Instructions: {
      Comments: `Comments`,
      FollowTruckId: `Follow Truck ID`,
    },
    Order: {
      Status: `Status`,
    },
    PlantCoordinates: `Map Reference`,
    Product: {
      Additives: `Additives`,
      AggregatedSize: `Aggregated Size`,
      Description: `Product Description`,
      Slump: `Slump`,
    },
    Quantity: {
      Progress: `Quantity Progress`,
      Total: `Total`,
    },
    Site: {
      Address: `Site Address`,
    },
    TruckNumber: `Truck Number`,
  },
  DeliveryOrderStatus: ({ deliveryOrderStatus }) => {
    if (deliveryOrderStatus === DELIVERY_ORDER_STATUS_ALL) {
      return `All`;
    }
    if (deliveryOrderStatus === DELIVERY_ORDER_STATUS_COMPLETED) {
      return `Completed`;
    }
    if (deliveryOrderStatus === DELIVERY_ORDER_STATUS_DELIVERED) {
      return `Delivered`;
    }
    if (deliveryOrderStatus === DELIVERY_ORDER_STATUS_LIVE) {
      return `Live`;
    }
    if (deliveryOrderStatus === DELIVERY_ORDER_STATUS_SCHEDULED) {
      return `Scheduled`;
    }
    return throwDeliveryInvalidOrderStatusError(deliveryOrderStatus);
  },
});

i18nStore.add(I18N_LANG_ZH_CN, key, {
  Delivery: {
    Customer: {
      Name: `顾客姓名`,
    },
    DocketId: `票号`,
    DocketTime: `约会时间`,
    Instructions: {
      Comments: `注释`,
      FollowTruckId: `关注卡车ID`,
    },
    Order: {
      Status: `状态`,
    },
    PlantCoordinates: `地图参考`,
    Product: {
      Additives: `添加剂`,
      AggregatedSize: `聚合大小`,
      Description: `产品描述`,
      Slump: `暴跌`,
    },
    Quantity: {
      Progress: `数量进展s`,
      Total: `总
      `,
    },
    Site: {
      Address: `网站地址`,
    },
    TruckNumber: `卡车号码`,
  },
  DeliveryOrderStatus: ({ deliveryOrderStatus }) => {
    if (deliveryOrderStatus === DELIVERY_ORDER_STATUS_ALL) {
      return `所有`;
    }
    if (deliveryOrderStatus === DELIVERY_ORDER_STATUS_COMPLETED) {
      return `已完成`;
    }
    if (deliveryOrderStatus === DELIVERY_ORDER_STATUS_DELIVERED) {
      return `交付`;
    }
    if (deliveryOrderStatus === DELIVERY_ORDER_STATUS_LIVE) {
      return `生活`;
    }
    if (deliveryOrderStatus === DELIVERY_ORDER_STATUS_SCHEDULED) {
      return `排定`;
    }
    return throwDeliveryInvalidOrderStatusError(deliveryOrderStatus);
  },
});
